//@import dependencies
import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import BreadcrumbComponent from 'app_components/commons/breadcrumb';
import AppContainer from 'app_components/layouts/app'
import UserForm from 'app_components/modules/admin/user/userForm'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../studentAdministratorScreen.scss'
import InputComponent from 'app_components/commons/Input/InputComponent';
import { useForm } from 'react-hook-form';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import CourseSchedulingEnrollmentService from 'app_services/admin/courseScheduling/courseSchedulingEnrollmentService';
import DataTableComponent from 'app_components/commons/dataTable';
import moment from 'moment';
import UserService from 'app_services/user/userService';
import { UserFormInputs } from 'app_types/admin/user/userTypes';
import TooltipComponent from 'app_components/commons/TooltipComponent/TooltipComponent';
import { MdEdit } from 'react-icons/md';
import { BsCardList } from 'react-icons/bs';
import ModalShowStudentCertifications from './components/ModalShowStudentCertifications/ModalShowStudentCertifications';

// @ADD Component types
interface IStudentAdministratorScreenLayoutProps {}

const StudentAdministratorScreenLayout: React.FC<IStudentAdministratorScreenLayoutProps> = (props) => {

  const userService: UserService = new UserService()
  const { t } = useTranslation();
  const formHook = useForm();
  const [enrollments, updateEnrollments] = useState<any[]>([]);
  const [loading, updateLoading] = useState<boolean>(false);
  const [edit, setEdit] = useState<any>(null);
  const [formData, setFormData] = useState<any>({})
  const [activeUser, setActiveUser] = useState<any>(null)

  // Servicios
  const courseSchedulingEnrollmentService = new CourseSchedulingEnrollmentService();

  const handleSubmit = (data: any) => {
    setFormData(data);
    searchEnrollments(data);
  }

  const searchEnrollments = async (params: any) => {
    updateLoading(true);
    const response = await courseSchedulingEnrollmentService.findStudents(params);
    if (response?.code === 200 && response?.enrollments) {
      formatDates(response.enrollments);
    }
    updateLoading(false);
  }

  const formatDates = (_enrollments: any[]) => {
    const newRegisters = _enrollments;
    newRegisters.forEach((register, idx) => {
      if (register.course_scheduling_doc?.startDate) {
        newRegisters[idx].course_scheduling_doc.startDate = moment(register.course_scheduling_doc.startDate).format('YYYY-MM-DD');
      }
      if (register.course_scheduling_doc?.endDate) {
        newRegisters[idx].course_scheduling_doc.endDate = moment(register.course_scheduling_doc.endDate).format('YYYY-MM-DD');
      }
      if (register.auditCertificate?.date) {
        newRegisters[idx].auditCertificate.date = moment(register.auditCertificate.date).format('YYYY-MM-DD');
      }
      if (register.academicCertificate?.date) {
        newRegisters[idx].academicCertificate.date = moment(register.academicCertificate.date).format('YYYY-MM-DD');
      }
    })
    updateEnrollments(newRegisters);
  }

  const showEditUserForm = async (edit: boolean, user?: any) => {
    if (edit) {
      const userData = await userService.getOne(user?.user)
      if (userData) {
        setEdit({
          ...userData,
          details: userData
        })
      } else {
        setEdit(null)
      }
    } else {
      setEdit(null)
    }
  }

  const updateUser = async () => {
    searchEnrollments(formData)
    setEdit(null)
  }


  return(
    <AppContainer>
      <div className='container-fluid student_administrator_screen-layout'>
        <BreadcrumbComponent links={['#']} texts={[`${t(`components.breadcrumb.student_administrator`)}`]} />
        {!edit ? (
          <>
            <h2>Administración de estudiantes</h2>
            <form
              className="container-buttons-filter"
              onSubmit={formHook.handleSubmit(handleSubmit)}
            >
              <InputComponent
                label='Nombre o apellido'
                placeholder='Nombre o apellido'
                name="name"
                formHook={formHook.register()}
                defaultValue={formData?.name}
              />
              <InputComponent
                label='Número de cédula'
                placeholder='Número de cédula'
                name="docNumber"
                formHook={formHook.register()}
                defaultValue={formData?.docNumber}
              />
              <InputComponent
                label='Email'
                placeholder='Email'
                name="email"
                formHook={formHook.register()}
                defaultValue={formData?.email}
              />
              <ButtonComponent
                variant='secondary'
                type='submit'
                style={{marginBottom: '1px'}}
                loading={loading}
              >
                Buscar
              </ButtonComponent>
            </form>
            <DataTableComponent
              data={enrollments}
              headerKeys={[
                'Identificador del servicio',
                `Programa`,
                `Fecha de inicio`,
                `Fecha de finalización`,
                'Nombres',
                'Apellidos',
                'Número de documento',
              ]}
              keys={[
                'course_scheduling_doc.metadata.service_id',
                'program_doc.name',
                'course_scheduling_doc.startDate',
                'course_scheduling_doc.endDate',
                'user_doc.profile.first_name',
                'user_doc.profile.last_name',
                'user_doc.profile.doc_number',
              ]}
              tooltipKeys={[
                'program_doc.name',
              ]}
              hideTooltip
              rowButtons={(row) => (
                <div style={{ display: 'flex', gap: '14px', alignItems: 'center' }}>
                  {userService.can('permission:students_update', 'module:users') && (
                    <TooltipComponent text="Editar">
                      <MdEdit
                        onClick={() => showEditUserForm(true, row)}
                        cursor="pointer"
                        color="var(--primary)"
                        size="20px"
                      />
                    </TooltipComponent>
                  )}
                  <TooltipComponent text="Ver certificados" >
                    <BsCardList
                      cursor="pointer"
                      color="var(--primary)"
                      onClick={() => setActiveUser(row)}
                      size={20}
                    />
                  </TooltipComponent>
                </div>
              )}
            />
          </>
        ) : (
          <div className="user-container-form col-6 mb-3">
            <div className="d-flex align-items-center mb-2">
              <>
                <h2 className="form-title">
                  {t(`screens.users_student.edit_layout.title_page`, {user: `${edit?.profile?.first_name} ${edit?.profile?.last_name}`})}
                </h2>
                <button className="btn btn-light btn-sm border ml-2" onClick={() => showEditUserForm(false)}>
                  {t("buttons.back")}
                </button>
              </>
            </div>
            <UserForm
              editData={edit}
              onHandleSubmit={updateUser}
              viewer={false}
              role={undefined}
              show_inputs={[
                UserFormInputs.FIRST_NAME,
                UserFormInputs.LAST_NAME,
                UserFormInputs.USERNAME,
                UserFormInputs.EMAIL,
                UserFormInputs.PHONE_NUMBER,
                UserFormInputs.DOC_NUMBER,
                UserFormInputs.DOC_TYPE,
                UserFormInputs.PASSWORD,
                UserFormInputs.TIMEZONE,
                UserFormInputs.DIALECT,
                UserFormInputs.ROLES,
              ]}
              editabled_inputs={[
                UserFormInputs.FIRST_NAME,
                UserFormInputs.LAST_NAME,
                UserFormInputs.EMAIL,
                UserFormInputs.PHONE_NUMBER,
                UserFormInputs.DOC_TYPE,
                UserFormInputs.PASSWORD,
              ]}
            />
          </div>
        )}
        <ModalShowStudentCertifications
          open={!!activeUser}
          onClose={() => setActiveUser(null)}
          enrollment={activeUser}
        />

      </div>
    </AppContainer>
  )
}

export default StudentAdministratorScreenLayout
